export default __webpack_public_path__ + "static/igd-logo-0891a65f290da7a3d4bd834a727bb566.svg";